import React from 'react';
import { useNavigate } from 'react-router-dom';

const PropertyListings = ({ listings, agent, onSelectProperty }) => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="section-header">
        <h2 className="section-title">LATEST PROPERTY LISTINGS</h2>
        <button 
          className="link-view-all btn-link-view-all"
          onClick={() => {
            navigate('/all-listings');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          VIEW ALL LISTINGS <i className="bi bi-arrow-right"></i>
        </button>
      </div>

      <div className="listings-grid">
        {listings && listings.map((item) => {
          const text = `Hi Nicole, I'm interested in the property listing #${item.id}: ${item.title} in ${item.area} (${item.price}). Could you please share more details?`;
          const whatsappUrl = `https://wa.me/${agent?.whatsappNumber || '60163288120'}?text=${encodeURIComponent(text)}`;

          return (
            <div 
              className="listing-card" 
              key={item.id} 
              style={{ cursor: 'pointer' }}
              onClick={() => onSelectProperty && onSelectProperty(item)}
            >
              <div className="listing-image-container">
                <img src={item.imageUrl} alt={item.title} className="listing-image" />
                <span className={`listing-tag ${item.listingType === 'FOR RENT' ? 'rent' : ''}`}>
                  {item.listingType}
                </span>
              </div>
              <div className="listing-content">
                <div className="listing-price">{item.price}</div>
                <div className="listing-title" title={item.title}>{item.title}</div>
                <div className="listing-location" title={item.area}>
                  <i className="bi bi-geo-alt"></i> <span>{item.area}</span>
                </div>
                {item.date && (
                  <div className="listing-date">
                    <i className="bi bi-clock"></i> <span>Listed on {item.date}</span>
                  </div>
                )}

                <div className="listing-specs">
                  <div className="spec-item" title="Bedrooms">
                    <i className="bi bi-door-closed"></i> {item.bedrooms}
                  </div>
                  <div className="spec-item" title="Bathrooms">
                    <i className="bi bi-droplet"></i> {item.bathrooms}
                  </div>
                  <div className="spec-item" title="Dimensions / Size">
                    <i className="bi bi-aspect-ratio"></i> {item.size}
                  </div>
                </div>

                <div className="listing-actions">
                  <button 
                    className="btn-view-details"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelectProperty && onSelectProperty(item);
                    }}
                  >
                    VIEW DETAILS
                  </button>
                  <a 
                    href={whatsappUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn-whatsapp-icon"
                    title="Enquire on WhatsApp"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="bi bi-whatsapp"></i>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PropertyListings;
